<ng-container *ngIf="opportunityTypes$ | async as availableTypes">
  <glxy-form-field appearance="outline">
    <glxy-label>{{ 'FRONTEND.SALES_OPPORTUNITIES.OPPORTUNITY_TYPE.PLACEHOLDER' | translate }}</glxy-label>
    <mat-select
      [value]="(selectedType$ | async)?.id"
      [placeholder]="'FRONTEND.SALES_OPPORTUNITIES.OPPORTUNITY_TYPE.PLACEHOLDER' | translate"
      (selectionChange)="emitTypeChange($event.value)"
    >
      <mat-option *ngFor="let type of availableTypes" [value]="type.id">
        {{ type.displayName | translate }}
      </mat-option>
    </mat-select>
  </glxy-form-field>
</ng-container>
